import React, { useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMessage } from "@hookform/error-message";
import toast from "react-hot-toast";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import ContactUsValidation from "../../validations/auth/ContactUsValidation";

interface FormInputs {
    email: string;
    name: string;
    subject: string;
    description?: string;
};

interface ContactUsPublicProps {
    onSuccess?: () => void;
}

const ContactUsPublic = ({ onSuccess }: ContactUsPublicProps) => {
    const contactUs = useMakeRequest();
    const { register, reset, formState: { errors }, handleSubmit } = useForm<FormInputs>({
        mode: 'onChange',
        resolver: yupResolver(ContactUsValidation),
    });

    const onSubmit = (formInputs: FormInputs) => {
        toast.promise(
            contactUs.makeRequest({ url: ApiConstants?.ContactUs, payload: formInputs })
                .then((res) => {
                    if (res?.status) {
                        onSuccess?.();
                        return res;
                    }
                }),
            {
                loading: 'Processing...',
                success: (data: any) => data?.message || "Success!",
                error: (error: any) => error?.message || "Something went wrong",
            }
        )
    }

    useEffect(() => {
        if (contactUs?.status) {
            reset();
        }
    }, [contactUs?.status])

    return (
        <main id="main-content" className="contact-us-public">
            <div className="contact-data">
                <h1 className="mb-5 heading-line fw-medium text-center">Get In Touch</h1>
                <form className='auth-form-wrap' onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Email<span className='label-star'>*</span></label>
                        <input
                            {...register('email')}
                            className="form-control"
                            placeholder='Enter email'
                        />
                        <ErrorMessage
                            errors={errors}
                            name="email"
                            render={({ message }) => <p className='valid-error'>{message}</p>}
                        />
                    </div>
                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Name<span className='label-star'>*</span></label>
                        <input
                            {...register('name')}
                            className="form-control"
                            placeholder='Enter name'
                        />
                        <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => <p className='valid-error'>{message}</p>}
                        />
                    </div>
                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Subject<span className='label-star'>*</span></label>
                        <input
                            {...register('subject')}
                            className="form-control"
                            placeholder='Enter subject'
                        />
                        <ErrorMessage
                            errors={errors}
                            name="subject"
                            render={({ message }) => <p className='valid-error'>{message}</p>}
                        />
                    </div>
                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Description</label>
                        <textarea
                            className="form-control h-auto resize-none"
                            rows={5}
                            placeholder='How can we help?'
                            {...register('description')}
                        ></textarea>
                        <ErrorMessage
                            errors={errors}
                            name="description"
                            render={({ message }) => <p className='valid-error'>{message}</p>}
                        />
                    </div>
                    <button className='com-btn mt-5 mx-auto' type='submit' disabled={contactUs?.loading}>
                        {contactUs?.loading ? 'Submitting...' : 'Submit'}
                    </button>
                </form>
            </div>
        </main>
    )
}

export default ContactUsPublic;
